<template>
  <section class="content" style="background-color: #EBECF1">
    <div class="row">
      <div class="col-md-12">
        <div class="box box-info">
          <div class="box-header">
            <h3 class="fuente box-title p-t-10">MANTENIMIENTO DE ROLES</h3>
          </div>
          <div class="box-body">
            <form role="form">
              <div class="row">
                <div class="box-body">
                  <div class="fuente col-xs-12">
                    <strong>APLICACIÓN</strong>
                  </div>
                  <div class="col-xs-6">
                    <!----
                    <select class="fuente form-control m-t-10 m-b-10" v-on:change="limpiar()" v-model="idAppFil">
                      <option v-for="app in apps" v-bind:value="app.idApp">
                        {{ app.descripcion }}
                      </option>
                    </select>
                    ---->
                    <v-select v-model="selectedIdApp" :options="filteredApps" :filterable="true" label="nombreApp"
                      @input="selectApp" class="fuente form-control m-t-10 m-b-10 combobox-personalizado4"
                      placeholder="SELECCIONAR APLICACIÓN"
                      style="width: 100%; max-width: 550px; padding: 0px; border-style: hidden;">
                      <template v-slot:no-options="{ search }">
                        Lo siento, no hay aplicaciones que coincidan con "{{ search }}".
                      </template>
                    </v-select>
                  </div>
                </div>
              </div>
              <div class="box-footer" style="padding-left:15px;">
                <button type="button" class="fuente btn btn-primary fs-13" @click="limpiar()" data-toggle="modal"
                  data-target="#modalNuevo">Nuevo Registro</button>
              </div>
              <div class="row">
                <div class="fuente col-xs-12 table-responsive">
                  <div class="box-body">
                    <table aria-describedby="tablaDetalle_info" role="grid" id="tablaDetalle"
                      class="fuente fs-12 table table-bordered table-striped dataTable">
                      <thead>
                        <tr role="row">
                          <th aria-label="ITEM" aria-sort="ascending" aria-controls="tablaDetalle" tabindex="0"
                            class="sorting_asc">ITEM</th>
                          <th aria-label="URL" aria-controls="tablaDetalle" tabindex="0" class="sorting">ROL</th>
                          <th aria-label="MODIFICAR" aria-controls="tablaDetalle" tabindex="0" class="sorting table-center-header">MODIFICAR
                          </th>
                          <th aria-label="OPERACIONES" aria-controls="tablaDetalle" tabindex="0" class="sorting table-center-header">
                            OPERACIONES
                          </th>
                          <th aria-label="DETALLE" aria-controls="tablaDetalle" tabindex="0"
                            class="sorting table-center-header">
                            DETALLE
                          </th>
                          <th aria-label="ANULAR" aria-controls="tablaDetalle" tabindex="0" class="sorting table-center-header">ANULAR</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr class="even" role="row" v-for="item in rols">
                          <td class="sorting_1">{{ item.cont }}</td>
                          <td>{{ item.descripcion }}</td>
                          <td class="table-center-header"><span style="cursor:pointer" class="badge bg-blue" data-toggle="modal" @click="ver(item)"
                              data-target="#modalNuevo">O</span></td>
                          <td class="table-center-header"><span style="cursor:pointer" class="badge bg-green" data-toggle="modal"
                              @click="verOperaciones(item)" data-target="#modalOperaciones">V</span></td>
                          <td class="table-center-header">
                            <router-link
                              :to="{ name: 'rol_detalle' /*, params: { idRol: item.idRol }*/ }">
                              <span @click="enviar(item, selectedIdApp)" class="badge bg-yellow">D</span>                              
                            </router-link>
                          </td>
                          <td class="table-center-header"><span style="cursor:pointer" class="badge bg-red" data-toggle="modal"
                              @click="verAnular(item)" data-target="#modalAnular">X</span></td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div class="fuente col-md-12" style="color: red;">
                    {{ error.desError }}
                  </div>
                </div>
              </div>
              <div class="modal fade" id="modalNuevo" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">
                <div class="modal-dialog" role="document">
                  <div class="modal-content">
                    <form>
                      <div class="modal-header">
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span
                            aria-hidden="true">X</span></button>
                        <h4 class="fuente modal-title m-t-10" id="myModalLabel">{{ texto }}</h4>
                      </div>
                      <div class="fuente modal-body fs-12">
                        Descripción:<br />
                        <input type="text" class="form-control m-t-10" v-model="rol.descripcion" /><br />
                        Aplicación:<br />
                        <!----
                        <select class="form-control m-t-10" v-model="rol.idApp">
                          <option v-for="app in apps" v-bind:value="app.idApp">
                            {{ app.descripcion }}
                          </option>
                        </select>
                        ---->
                        <v-select v-model="selectedIdApp" :options="filteredApps" :filterable="true" label="nombreApp"
                          @input="selectApp" class="fuente form-control m-t-10 m-b-10 combobox-personalizado5"
                          placeholder="Seleccionar Aplicación"
                          style="width: 100%; max-width: 550px; padding: 0px; border-style: hidden;">
                          <template v-slot:no-options="{ search }">
                            Lo siento, no hay aplicaciones que coincidan con "{{ search }}".
                          </template>
                        </v-select>
                      </div>
                      <div class="modal-footer">
                        <button type="button" class="fuente btn btn-primary fs-13" @click="merge()" data-dismiss="modal"
                          :disabled="!rol.descripcion"
                          :title="!rol.descripcion ? 'Si desea guardar, complete el campo Descripción' : ''"> Guardar
                          Cambios</button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
              <div class="modal fade" id="modalAnular" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">
                <div class="modal-dialog" role="document">
                  <div class="modal-content">
                    <form>
                      <div class="modal-header">
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span
                            aria-hidden="true">X</span></button>
                        <h4 class="fuente modal-title m-t-10" id="myModalLabel">¿DESEA ANULAR EL ROL?</h4>
                      </div>
                      <div class="fuente modal-body">
                        Se anulará el rol {{ rol.descripcion }} <br />
                      </div>
                      <div class="modal-footer">
                        <button type="button" class="fuente btn btn-danger fs-13" @click="merge()"
                          data-dismiss="modal">Anular Rol</button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
              <div class="modal fade" id="modalOperaciones" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">
                <div class="modal-dialog" role="document">
                  <div class="modal-content">
                    <form>
                      <div class="modal-header">
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span
                            aria-hidden="true">X</span></button>
                        <h4 class="fuente modal-title m-t-10" id="myModalLabel">OPERACIONES POR ROL: {{ rol.descripcion }}
                        </h4>
                      </div>
                      <div class="modal-body">
                        <div class="row">
                          <div class="fuente col-md-12 fs-12">
                            Operación :
                          </div>
                          <div class="col-md-9">
                            <select class="form-control m-t-10" v-model="opeByRol.idOperacion"
                              :disabled="opeByApp.length === 0">
                              <template v-if="opeByApp.length > 0">
                                <option disabled value="0" selected hidden>Seleccionar Operación</option>
                                <option v-for="app in opeByApp" v-bind:value="app.idOperacion">
                                  {{ app.descripcion }}
                                </option>
                              </template>
                              <template v-else>
                                <option disabled value="0" selected hidden>No hay operaciones disponibles
                                </option>
                              </template>
                            </select>
                          </div>
                          <div class="col-md-3 m-t-12">
                            <button type="button" @click="mergeOpeByRol(rol.idRol)"
                              class="fuente btn btn-primary fs-13">AGREGAR +</button>
                          </div>
                          <div class="col-md-12" style="color: red;">
                            {{ error.desError }}
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-12">
                            <br />
                            <table aria-describedby="tablaDetalle_info" role="grid" id="tbRols"
                              class="fuente fs-12 table table-bordered table-striped dataTable">
                              <thead>
                                <tr role="row">
                                  <th aria-label="ITEM" aria-sort="ascending" aria-controls="tbRols" tabindex="0">ITEM
                                  </th>
                                  <th aria-label="APP" aria-controls="tbRols" tabindex="0">ROL</th>
                                  <th aria-label="ANULAR" aria-controls="tbRols" tabindex="0">ANULAR</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr class="even" role="row" v-for="item in opeXRol">
                                  <td class="sorting_1">{{ item.cont }}</td>
                                  <td>{{ item.descripcion }}</td>
                                  <td><span style="cursor:pointer" class="badge bg-red" data-toggle="modal"
                                      @click="anularOpeByRol(item)">X</span></td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>

import 'datatables.net'
import 'datatables.net-bs'
import axios from 'axios'
import $ from 'jquery'
import { apiURL, apiLOGIN } from '@/store/state'
import Swal from 'sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
//import App from '../App.vue';
import App from '@/components/App.vue';
import moment from 'moment';

export default {
  name: 'Tables',
  data() {
    return {
      apps: [],
      texto: '',
      idAppFil: '1',
      vidRol: '0',
      rols: [],
      error: {
        desError: ''
      },
      opeXRol: [],
      opeByApp: [],
      opeByRol: {
        idRol: '0',
        idOpeXRol: '0',
        idOperacion: '0',
        flagActivo: '1',
        usuario: this.$session.get('user')
      },
      rol: {
        idRol: '0',
        descripcion: '',
        idApp: '1',
        flagActivo: '1',
        usuario: this.$session.get('user')
      },
      //// Obtiene las opexrol según el id de Rol para Anular Rol
      getOpexRol: [],
      tiempoActual: null,
      tiempoTokenExp: null,
      /// del v-select
      searchText: '',
      selectedIdApp: null,
      appSeleccionada: {},
    }
  },
  components: {
    vSelect
  },
  mounted() {
    //this.tiempoActual = new Date().toLocaleString('es-PE', { timeZone: 'America/Lima' });
    //this.tiempoTokenExp = localStorage.getItem('TokenExpirationTime')
    this.tiempoActual = moment(new Date().toLocaleString('es-PE', { timeZone: 'America/Lima' }), "D/M/YYYY, h:mm:ss a");
    this.tiempoTokenExp = moment(localStorage.getItem('TokenExpirationTime'), "D/M/YYYY, h:mm:ss a");
    
    if (!this.$session.exists('token')) {
      App.methods.logout.call(this);
      return;
    }

    if (this.tiempoActual < this.tiempoTokenExp) {
      axios.defaults.headers.common['Authorization'] = this.$session.get('token')
      // Realizar la validación con la API
      axios.get(`${apiLOGIN}/operaciones/app/GESU/roles`)
        .then(response => {

          //console.log("API validador de permisos:", response)
          if (response.data.codError === 1 || response.data.desError === 'ok') {
            // La validación es exitosa, continuar con la carga de datos
            this.carga();
          } else {
            // La validación no es exitosa, redirigir a la vista anterior
            //console.log("Usuario No Autorizado")
            //this.$router.go(-1);
            this.alertaError();
          }
        })
        .catch(error => {
          if (error.response && error.response.status === 401) {
            // Manejar el caso de error de autorización
            //this.$router.go(-1);
            this.alertaError401();
          } else if (error.response && error.response.status === 403) {            
            //this.$router.go(-1);
            this.alertaError();
          } else if (error.response && error.response.status === 500) {
            //this.$router.go(-1); 
            this.alertaError500();
          } else {            
            //this.$router.go(-1);
            this.alertaError401();
          }
        });
    } else {
      this.alertaError401();
    }
  },
  methods: {
    carga: function () {
      axios.get(
        //'https://tomcat.sedetc.gob.pe/cas-services-0.0.2/aplicaciones/*'
        `${apiURL}/aplicaciones/*`
      ).then(response => {
        this.apps = response.data
      })
        .catch(error => {
          if (error.response.status === 401) {
            App.methods.logout.call(this);
          }
        })
      // axios.defaults.headers.common['Authorization'] = this.$session.get('token')
      // axios.get(`${apiURL}/operaciones/rolByApp/1`)
      //   .then(response => {
      //   this.rols = response.data
      //   this.$nextTick(() => {
      //     $('#tablaDetalle').DataTable({
      //       'oLanguage': {
      //         'sSearch': 'Buscar',
      //         'sInfo': 'Mostrando _START_ al _END_ de _TOTAL_ registros',
      //         'sEmptyTable': 'Sin Data',
      //         'ZeroRecords': 'No se encontraron coincidencias',
      //         'sInfoFiltered': '(Filtrado de un total de _MAX_ registros)',
      //         'sLengthMenu': '_MENU_ Registros por pagina',
      //         'oPaginate': {
      //           'sPrevious': 'Anterior',
      //           'sNext': 'Siguiente'
      //         }
      //       }
      //     })
      //   })
      // })
      // .catch(error => {
      //   if (error.response.status === 401) {
      //     this.$session.destroy()
      //     this.$router.push('/login')
      //   }
      // })
    },
    merge: function () {
      if (moment(new Date().toLocaleString('es-PE', { timeZone: 'America/Lima' }), "D/M/YYYY, h:mm:ss a") < this.tiempoTokenExp) {
        ///////Anular OpexRol, en caso de que getOpeByRol exista (el que se ejecutó en verAnular)
        if (this.getOpexRol && this.getOpexRol.length > 0) {
          this.getOpexRol.forEach((array2) => {
            this.anularOpeByRol(array2);

            ////Anular con flagActivo 0 en la tabla operacion
            axios.post(
              //'https://tomcat.sedetc.gob.pe/cas-services-0.0.2/operaciones/ope/add',
              `${apiURL}/operaciones/ope/add`,
              {
                'idOperacion': array2.idOperacion,
                'descripcion': array2.descripcion,
                'idApp': array2.idApp,
                'flagPrincipal': array2.flagPrincipal,
                'enlaceWeb': array2.enlaceWeb,
                'idOpeSup': array2.idOpeSup,
                'flagSeccion': array2.flagSeccion,
                'icono': array2.icono,
                'titulo_adic': array2.titulo_adic,
                'icono_adic': array2.icono_adic,
                'descripcion_adic': array2.descripcion_adic,
                'flagActivo': 0,
                'usuario': this.$session.get('user')
              }
            ).then(response => {
              this.error3 = response.data
            }).catch(error => {
              if (error.response && error.response.status === 401) {
                App.methods.logout.call(this);
              }
            })
          });
        } else { }

        axios.post(
          //'https://tomcat.sedetc.gob.pe/cas-services-0.0.2/operaciones/rol/add',
          `${apiURL}/operaciones/rol/add`,
          {
            'idRol': this.rol.idRol,
            'descripcion': this.rol.descripcion,
            'idApp': this.rol.idApp,
            'flagActivo': this.rol.flagActivo,
            'usuario': this.$session.get('user')
          }
        ).then(response => {
          this.error = response.data
          this.carga()
          this.limpiar()          
        })
          .catch(error => {
            if (error.response && error.response.status === 401) {
              App.methods.logout.call(this);
            }
          })
      } else {
        this.alertaError401();
      }
    },
    ver: function (rol) {
      //this.rol = rol
      this.rol = { ...rol };
      this.rol.idApp = this.idAppFil
      this.texto = 'ACTUALIZAR ROL'
      this.error.desError = ''
    },
    verAnular: function (rol) {
      this.rol = { ...rol }
      this.rol.flagActivo = '0'
      this.obtenerOpexRol(this.rol.idRol);
      this.error.desError = ''
      //console.log('---- rol en verAnular', rol);
    },
    verOperaciones: function (rol) {
      this.error.desError = ''
      this.rol = rol
      this.rol.idApp = this.idAppFil
      this.error.desError = ''
      //console.log('rol--', this.rol)      
      axios.get(
        //'https://tomcat.sedetc.gob.pe/cas-services-0.0.2/operaciones/I/' + rol.idApp + '/0' 
        `${apiURL}/operaciones/I/` + rol.idApp + '/0'
      ).then(response => {
        //this.opeByApp = response.data
        //// Filtrar para que no se muestren las Operaciones duplicadas en el combobox
        this.opeByApp = this.eliminarOpeDuplicados(response.data, 'descripcion');
      })
        .catch(error => {
          if (error.response && error.response.status === 401) {
            App.methods.logout.call(this);
          }
        })
      //console.log('ver Operaciones opeByApp--', this.opeByApp)
      axios.get(
        //'https://tomcat.sedetc.gob.pe/cas-services-0.0.2/operaciones/opeByRol/' + rol.idRol 
        `${apiURL}/operaciones/opeByRol/` + rol.idRol
      ).then(response => {
        this.opeXRol = response.data
      })
        .catch(error => {
          if (error.response.status === 401) {
            App.methods.logout.call(this);
          }
        })

      //console.log('opeXRol--', this.opeXRol)
    },
    mergeOpeByRol: function (vidRol) {
      this.opeByRol.idRol = vidRol
      axios.post(
        //'https://tomcat.sedetc.gob.pe/cas-services-0.0.2/operaciones/opeByRol/add',
        `${apiURL}/operaciones/opeByRol/add`,
        {
          'idOpeXRol': '0',
          'idRol': this.opeByRol.idRol,
          'idOperacion': this.opeByRol.idOperacion,
          'flagActivo': this.opeByRol.flagActivo,
          'usuario': this.$session.get('user')
        }
      ).then(response => {
        this.error = response.data
        axios.get(
          //'https://tomcat.sedetc.gob.pe/cas-services-0.0.2/operaciones/opeByRol/' + vidRol 
          `${apiURL}/operaciones/opeByRol/` + vidRol
        ).then(response => {
          this.opeXRol = response.data
        })
          .catch(error => {
            if (error.response.status === 401) {
              App.methods.logout.call(this);
            }
          })
      })
        .catch(error => {
          if (error.response.status === 401) {
            App.methods.logout.call(this);
          }
        })
    },
    ///////////////////////////    
    //// Obtener las opexrol según id de Operación
    obtenerOpexRol: function (vidRol) {
      axios.get(
        `${apiURL}/operaciones/opexrolByRol/` + vidRol
      ).then(response => {
        this.getOpexRol = response.data
        //console.log('--- getOpexRol en Anular Rol:', this.getOpexRol);
      })
        .catch(error => {
          if (error.response.status === 401) {
            App.methods.logout.call(this);
          }
        })
    },
    /////////////////
    anularOpeByRol: function (opeByRol) {
      this.opeByRol.idOpeXRol = opeByRol.idOpeXRol
      axios.post(
        //'https://tomcat.sedetc.gob.pe/cas-services-0.0.2/operaciones/opeByRol/add',
        `${apiURL}/operaciones/opeByRol/add`,
        {
          'idOpeXRol': this.opeByRol.idOpeXRol,
          'idRol': this.opeByRol.idRol,
          'idOperacion': this.opeByRol.idOperacion,
          'flagActivo': '0',
          'usuario': this.$session.get('user')
        }
      ).then(response => {
        this.error = response.data
        axios.get(
          //'https://tomcat.sedetc.gob.pe/cas-services-0.0.2/operaciones/opeByRol/' + this.rol.idRol 
          `${apiURL}/operaciones/opeByRol/` + this.rol.idRol
        ).then(response => {
          this.opeXRol = response.data
        })
          .catch(error => {
            if (error.response && error.response.status === 401) {
              App.methods.logout.call(this);
            }
          })
      })
        .catch(error => {
          if (error.response && error.response.status === 401) {
            App.methods.logout.call(this);
          }
        })
    },
    limpiar: function () {
      //console.log('apps', this.apps)      
      //console.log('rols', this.rols)

      axios.get(
        //'https://tomcat.sedetc.gob.pe/cas-services-0.0.2/operaciones/rolByApp/' + this.idAppFil 
        `${apiURL}/operaciones/rolByApp/` + this.idAppFil
      ).then(response => {
        this.rols = response.data
        $('#tablaDetalle').dataTable().fnDestroy()
        this.$nextTick(() => {
          $('#tablaDetalle').DataTable({
            stateSave: true,
            'stateSaveParams': function (settings, data) {
              data.length = 25;
            },
            pageLength: 25,
            'oLanguage': {
              'sSearch': 'Buscar',
              'sInfo': 'Mostrando _START_ al _END_ de _TOTAL_ registros',
              'sEmptyTable': 'Sin Data',
              'ZeroRecords': 'No se encontraron coincidencias',
              'sInfoFiltered': '(filtrado de un total de _MAX_ registros)',
              'sLengthMenu': '_MENU_ Registros por pagina',
              'oPaginate': {
                'sPrevious': 'Anterior',
                'sNext': 'Siguiente'
              }
            }
          })
        })
      })
        .catch(error => {
          if (error.response.status === 401) {
            App.methods.logout.call(this);
          }
        })
      this.texto = 'REGISTRAR ROL'
      this.rol.idRol = '0'
      this.rol.descripcion = ''
      this.rol.idApp = this.idAppFil
      this.rol.flagActivo = '1'
    },
    ////Filtrar para no mostrar Operaciones duplicadas en el combobox del botón Operaciones
    eliminarOpeDuplicados: function (array, propiedad) {
      // Función para eliminar elementos duplicados en base a una propiedad
      return array.filter((valor, indice, self) =>
        self.findIndex(item => item[propiedad] === valor[propiedad]) === indice
      );
    },
    /// del v-select de Aplicaciones
    selectApp() {
      if (this.selectedIdApp && this.selectedIdApp.idApp) {
        //console.log('Ejecutando selectApp', this.selectedIdApp);
        this.idAppFil = this.selectedIdApp.idApp
        this.limpiar()
        this.error.desError = ''        
      } else {
        //console.warn('selectedIdArea es null o no tiene id');                       
        this.rols = []
        // Destruir la instancia DataTable si ya existe
        const dataTableInstance = $('#tablaDetalle').DataTable();
        if (dataTableInstance) {
          dataTableInstance.destroy();
        }
        this.error.desError = ''
      }
    },
    alertaError() {
      Swal.fire({
        icon: 'error',
        title: 'Usuario No Autorizado',
        text: 'No tienes permisos para acceder.',
        timer: 2000, // Duración en milisegundos
        timerProgressBar: true,
        showConfirmButton: false
      }).then(() => {
        // Se redirecionará a la vista anterior cuando se cierre el cuadro de diálogo.
        this.$router.go(-1);
      });
    },
    alertaError401() {
      Swal.fire({
        icon: 'error',
        title: 'La sesión ha expirado',
        //text: 'Vuelve a iniciar sesión.',
        footer: '<a href="#">Vuelve a iniciar sesión.</a>',
        timer: 3000, // Duración en milisegundos
        timerProgressBar: true,
        showConfirmButton: false
      }).then(() => {                
        //this.$session.destroy()
        //this.$router.push('/login')
        App.methods.logout.call(this); ///Cierra la sesión         
      });
    },
    alertaError500() {
      Swal.fire({
        icon: 'error',
        title: 'Error interno del servidor',
        text: 'Ocurrió un error. Por favor, inténtalo de nuevo más tarde..',
        timer: 5000, // Duración en milisegundos
        timerProgressBar: true,
        showConfirmButton: false
      }).then(() => {        
        this.$router.go(-1);
      });
    },
    enviar(itemRol, itemApp) {      
      //this.$router.push('/roles/');      
      localStorage.setItem('rol_idRol', itemRol.idRol)
      localStorage.setItem('rol_descripcionRol', itemRol.descripcion)
      localStorage.setItem('rol_idApp', itemApp.idApp)
      localStorage.setItem('rol_nombreApp', itemApp.nombreApp)
      //console.log('enviar item', localStorage.getItem('rol_idApp'))
    }
  },
  computed: {
    /// del v-select de Aplicaciones
    filteredApps() {
      const lowerSearchText = this.searchText.toLowerCase();
      return this.apps.map(app => {
        if (app && app.descripcion) {
          return {
            ...app,
            nombreApp: `${app.descripcion}`
          };
        }
        return null;
      }).filter(app => app && (
        app.descripcion.toLowerCase().includes(lowerSearchText)
      ));
    },
  }
}

</script>

<style>
table.dataTable thead .sorting:after,
table.dataTable thead .sorting_asc:after,
table.dataTable thead .sorting_desc:after {
  font-family: 'FontAwesome';
}

table.dataTable thead .sorting:after {
  content: "\f0dc";
}

table.dataTable thead .sorting_asc:after {
  content: "\f0dd";
}

table.dataTable thead .sorting_desc:after {
  content: "\f0de";
}
</style>



// WEBPACK FOOTER //
// Roles.vue?6ef53f39